import React, { useEffect, useState } from "react";
import "../Style/BookAppointment.css";
import {
  IoMdCheckmarkCircleOutline,
  IoMdCloseCircleOutline,
} from "react-icons/io";
import axios from "axios";
import { FaUser, FaEnvelope, FaPhoneAlt } from "react-icons/fa";
import { RiArrowDropDownLine } from "react-icons/ri";
import ap1 from "../Assets/ap1.png";
import { PiPhoneCallFill } from "react-icons/pi";
import {
  getAllDoctors,
  getDoctorTimeSlots,
  addAppointment,
  validateOtp,
  sendOtp,
  deleteAppointment,
  getConsultation,
} from "../backend";
import { IoCalendarNumberSharp } from "react-icons/io5";
import { useAuth } from "./UserContext.js";
import Loading from "./Loading.js";
import { useAppointment } from "./AppointmentContext.js";

const BookAppointment = ({ handleAppointment }) => {
  const { prefillData, appointmentData } = useAppointment();
  const { currentUser } = useAuth();
  const isMobile = window.innerWidth <= 768;

  const [selectedDoctor, setSelectedDoctor] = useState(null);
  const [selectedLocation, setSelectedLocation] = useState("Select Location");
  const [selectedConsultation, setSelectedConsultation] = useState(
    "Select Consultation Type",
  );

  const [isLoadingOtp, setIsLoadingOtp] = useState(false);
  const [showDoctorDropdown, setShowDoctorDropdown] = useState(false);
  const [showConsultationDropdown, setShowConsultationDropdown] =
    useState(false);
  const [showLocationDropdown, setShowLocationDropdown] = useState(false);

  const [date, setDate] = useState(new Date().toISOString().slice(0, 10));
  const [startDate, setStartDate] = useState(
    new Date().toISOString().split("T")[0],
  );
  const [timeSlots, setTimeSlots] = useState([]);
  const [emailOtp, setEmailOtp] = useState("");
  const [emailOtpSent, setEmailOtpSent] = useState(false);
  const [isEmailOtpValid, setIsEmailOtpValid] = useState(false);
  const [disabledSlots, setDisabledSlots] = useState([]);

  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    phoneNumber: "",
    age: "",
    gender: "",
  });

  const [address, setAddress] = useState({
    street: "",
    city: "",
    pincode: "",
    district: "",
    state: "",
  });

  const [doctors, setDoctors] = useState([]);
  const [filteredDoctors, setFilteredDoctors] = useState([]);

  const [selectedTime, setSelectedTime] = useState(null);
  const [isDoctorAvailable, setIsDoctorAvailable] = useState(true);
  const [consultationAmount, setConsultationAmount] = useState(300);
  const [doctorLocation, setDoctorLocation] = useState([]);

  const consultationType = ["Video", "Clinic Visit"];

  useEffect(() => {
    fetchAllDoctors();
  }, []);
  // Inside BookAppointment.js

  useEffect(() => {
    if (appointmentData && prefillData) {
      // 1. Set Form Data
      setFormData({
        firstName: prefillData.firstName || "",
        lastName: prefillData.lastName || "",
        email: prefillData.email || "", // Condition: Set email from prefill
        phoneNumber: prefillData.phoneNumber || "",
        age: prefillData.age || "",
        gender: prefillData.gender || "",
      });

      // 2. Set Address if previous was Video
      if (prefillData.consultationType === "Video" && prefillData.address) {
        setAddress({
          street: prefillData.address.street || "",
          city: prefillData.address.city || "",
          pincode: prefillData.address.pincode || "",
          district: prefillData.address.district || "",
          state: prefillData.address.state || "",
        });
      }

      // 3. Condition: If email exists in prefill, consider it already verified
      if (prefillData.email) {
        setIsEmailOtpValid(true);
        setEmailOtpSent(false); // Hide the "Send OTP" button
      }
    } else if (appointmentData && !prefillData) {
      // Clear form for fresh appointments
      setFormData({
        firstName: "",
        lastName: "",
        email: "",
        phoneNumber: "",
        age: "",
        gender: "",
      });
      setAddress({
        street: "",
        city: "",
        pincode: "",
        district: "",
        state: "",
      });
      setIsEmailOtpValid(false);
    }
  }, [appointmentData, prefillData]);
  // 🔹 UPDATED FILTER LOGIC
  useEffect(() => {
    if (selectedConsultation === "Video") {
      // Show doctors with type 'online' or 'both'
      const videoDoctors = doctors.filter(
        (doc) => doc.type === "online" || doc.type === "both",
      );
      setFilteredDoctors(videoDoctors);
    } else if (selectedLocation && selectedLocation !== "Select Location") {
      // Show doctors based on location for Clinic Visits
      const locDoctors = doctors.filter((doc) =>
        doc.locations.some((loc) => loc.trim() === selectedLocation.trim()),
      );
      setFilteredDoctors(locDoctors);
    } else {
      setFilteredDoctors(doctors);
    }

    // Reset selected doctor if they are no longer in the filtered list
    if (
      selectedDoctor &&
      !filteredDoctors.some((d) => d.id === selectedDoctor.id)
    ) {
      setSelectedDoctor(null);
    }
  }, [selectedLocation, selectedConsultation, doctors]);

  useEffect(() => {
    fetchConsultation();
  }, [selectedLocation, selectedConsultation]);

  useEffect(() => {
    if (selectedDoctor) {
      fetchDoctorTimeSlots(
        selectedDoctor.id,
        date,
        selectedLocation,
        selectedConsultation,
      );
    }
  }, [selectedDoctor, selectedLocation, date, selectedConsultation]);

  useEffect(() => {
    if (selectedConsultation === "Video" && selectedDoctor) {
      if (selectedDoctor.locations?.length > 0) {
        setSelectedLocation(selectedDoctor.locations[0]);
      }
    }
  }, [selectedConsultation, selectedDoctor]);

  const fetchAllDoctors = async () => {
    try {
      const response = await getAllDoctors();
      if (response) {
        const uniqueLocations = [
          ...new Set(
            response.doctors.flatMap((doctor) =>
              doctor.locations.map((location) => location.trim()),
            ),
          ),
        ];
        setDoctorLocation(uniqueLocations);
        setDoctors(response?.doctors);
        setFilteredDoctors(response?.doctors); // Initialize filtered list
      }
    } catch (error) {
      console.error("Error fetching doctors:", error);
    }
  };

  const fetchConsultation = async () => {
    try {
      const consultation = await getConsultation();
      console.log("Res cons", consultation);
      if (consultation) {
        let filterConsultation = consultation.filter((con) => {
          return (
            con.location === selectedLocation &&
            con.consultationType === selectedConsultation
          );
        });
        console.log("Filtered Loc", filterConsultation);
        setConsultationAmount(filterConsultation[0]?.consultationFee || 300);
      }
    } catch (error) {
      console.log("Error", error);
    }
  };

  const sendEmailOtp = async () => {
    if (!formData.email) {
      alert("Please enter email!");
      return;
    }
    setIsLoadingOtp(true);
    try {
      const response = await sendOtp(formData.email);
      if (response) {
        setEmailOtpSent(true);
        alert("OTP sent to your email.");
      } else {
        alert("Failed to send OTP.");
      }
    } catch (error) {
      console.error("OTP error", error);
    } finally {
      setIsLoadingOtp(false);
    }
  };

  const validateEmailOtp = async () => {
    setIsLoadingOtp(true);
    try {
      const response = await validateOtp(formData.email, emailOtp);
      if (response) {
        setIsEmailOtpValid(true);
        alert("Email verified.");
      } else {
        alert("Invalid OTP");
      }
    } catch (error) {
      console.error("Validate OTP error", error);
    } finally {
      setIsLoadingOtp(false);
    }
  };

  const fetchDoctorTimeSlots = async (
    id,
    date,
    selectedLocation,
    selectedConsultation,
  ) => {
    try {
      const response = await getDoctorTimeSlots(
        id,
        date,
        selectedLocation,
        selectedConsultation,
      );
      if (!response) {
        setTimeSlots([]);
        return;
      }
      const slots = response.slots;
      const disabled = slots
        .filter(
          (slot) => slot.status === "booked" || slot.status === "unavailable",
        )
        .map((slot) => slot.time);

      setTimeSlots(slots);
      setDisabledSlots(disabled);
    } catch (error) {
      console.error("Error fetching slots", error);
    }
  };

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleAddressChange = (e) => {
    setAddress({ ...address, [e.target.name]: e.target.value });
  };

  const handleSubmit = async () => {
    if (!isEmailOtpValid) {
      alert("Please verify email.");
      return;
    }
    if (
      !selectedTime ||
      !date ||
      !selectedDoctor ||
      selectedConsultation === "Select Consultation Type"
    ) {
      alert("Please select all fields.");
      return;
    }

    if (
      selectedConsultation !== "Video" &&
      selectedLocation === "Select Location"
    ) {
      alert("Please select location.");
      return;
    }

    const data = {
      ...formData,
      date,
      doctorName: selectedDoctor.name,
      doctorId: selectedDoctor.id,
      location: selectedLocation,
      consultationType: selectedConsultation,
      startTime: selectedTime,
      address: selectedConsultation === "Video" ? address : null,
      appointmentPaymentStatus: "Pending",
      appointmentPaymentId: "",
      medicines: {
        complain: [],
        remedies: [{ medicineName: "", dosage: "", frequency: "" }],
        potency: "",
        duration: "",
        pharmacyName: "",
        pharmacyId: "",
        instructions: "",
        showMedicine: "",
      },
    };

    try {
      const res = await addAppointment(data);
      let url =
        "https://apirk.drrkvishwakarma.com/api/payment/create-appointment";
      axios
        .post(`${url}`, {
          appointmentId: res.appointment.appointmentId,
          consultationAmount,
        })
        .then((response) => {
          window.location.href = response.data.checkoutPageUrl;
        });
    } catch (error) {
      alert(error);
    }
  };

  return (
    <div className="book-container" onClick={(e) => e.stopPropagation()}>
      <div className="book-container-1">
        <h1
          style={{
            textAlign: "center",
            margin: "20px 0px",
            fontSize: "30px",
            fontWeight: "600",
          }}
        >
          Book Appointment
        </h1>

        <div className="select-consultation-1" style={{ marginBottom: "20px" }}>
          <div
            className="select-location"
            style={{ width: "97.5%" }}
            onClick={() =>
              setShowConsultationDropdown(!showConsultationDropdown)
            }
          >
            <p>{selectedConsultation}</p>
            <RiArrowDropDownLine />
          </div>

          {showConsultationDropdown && (
            <ul className="dropdown-menu-22">
              {consultationType.map((consultation, index) => (
                <li
                  key={index}
                  onClick={() => {
                    setSelectedConsultation(consultation);
                    setShowConsultationDropdown(false);
                    // Reset doctor when changing consultation type to ensure valid selection
                    setSelectedDoctor(null);
                  }}
                >
                  {consultation}
                </li>
              ))}
            </ul>
          )}
        </div>

        <div className="select-doctor-location-1">
          {/* Show Location only for non-video */}
          {selectedConsultation !== "Video" && (
            <div className="select-location-1">
              <div
                className="select-location"
                onClick={() => setShowLocationDropdown(!showLocationDropdown)}
              >
                <p>{selectedLocation}</p>
                <RiArrowDropDownLine />
              </div>
              {showLocationDropdown && (
                <ul className="dropdown-menu-22">
                  {doctorLocation.map((location, index) => (
                    <li
                      key={index}
                      onClick={() => {
                        setSelectedLocation(location);
                        setShowLocationDropdown(false);
                      }}
                    >
                      {location}
                    </li>
                  ))}
                </ul>
              )}
            </div>
          )}

          {/* Doctor Dropdown - Now uses filteredDoctors from our new logic */}
          <div
            className="select-doctor-1"
            style={{ width: selectedConsultation === "Video" ? "100%" : "" }}
          >
            <div
              className="select-doctor"
              onClick={() => setShowDoctorDropdown(!showDoctorDropdown)}
            >
              <p>{selectedDoctor ? selectedDoctor.name : "Select Doctor"}</p>
              <RiArrowDropDownLine />
            </div>

            {showDoctorDropdown && (
              <ul className="dropdown-menu-22">
                {filteredDoctors?.map((doctor, index) => (
                  <li
                    key={index}
                    onClick={() => {
                      setSelectedDoctor(doctor);
                      if (
                        selectedConsultation === "Video" &&
                        doctor.locations.length > 0
                      ) {
                        setSelectedLocation(doctor.locations[0]);
                      }
                      setShowDoctorDropdown(false);
                    }}
                  >
                    {doctor.name}
                  </li>
                ))}
              </ul>
            )}
          </div>
        </div>

        {/* Form sections (User Info, Date, Slots, Address) same as original ... */}
        <div style={{ width: "90%", margin: "auto" }}>
          <div className="form-group">
            <div className="input-container">
              <FaUser />
              <input
                type="text"
                name="firstName"
                value={formData.firstName}
                placeholder="First Name"
                onChange={handleChange}
                required
              />
            </div>
            <div className="input-container">
              <FaUser />
              <input
                type="text"
                name="lastName"
                value={formData.lastName}
                placeholder="Last Name"
                onChange={handleChange}
              />
            </div>
          </div>

          <div className="form-group">
            <div className="input-container">
              <FaEnvelope />
              <input
                type="email"
                name="email"
                value={formData.email}
                placeholder="Email ID"
                onChange={handleChange}
                required
              />
            </div>
            <div className="input-container">
              {!emailOtpSent && !isEmailOtpValid && (
                <button
                  type="button"
                  onClick={sendEmailOtp}
                  className="verifi-btn"
                  style={{
                    padding: "3px 5px",
                    width: "90%",
                    margin: "auto",
                    backgroundColor: "#f3f1ff",
                    border: "none",
                    cursor: "pointer",
                  }}
                >
                  Send Email OTP
                </button>
              )}
              {isLoadingOtp && <Loading />}
              {emailOtpSent && !isLoadingOtp && !isEmailOtpValid && (
                <div style={{ display: "flex" }}>
                  <input
                    type="number"
                    placeholder="OTP*"
                    value={emailOtp}
                    onChange={(e) => setEmailOtp(e.target.value)}
                    required
                  />
                  <button
                    type="button"
                    onClick={validateEmailOtp}
                    className="verifi-btn"
                    style={{ padding: "6px" }}
                  >
                    Validate
                  </button>
                </div>
              )}
              {isEmailOtpValid && (
                <div style={{ display: "flex", width: "100%" }}>
                  <input type="number" value={emailOtp} readOnly />
                </div>
              )}
            </div>
          </div>

          <div className="input-container">
            <FaPhoneAlt />
            <input
              type="text"
              name="phoneNumber"
              value={formData.phoneNumber}
              placeholder="Phone Number"
              onChange={handleChange}
              required
            />
          </div>

          <div className="form-group">
            <div className="input-container">
              <IoCalendarNumberSharp />
              <input
                type="text"
                name="age"
                value={formData.age}
                placeholder="Age"
                onChange={handleChange}
                required
              />
            </div>
            <div className="input-container">
              <select
                name="gender"
                value={formData.gender}
                onChange={handleChange}
                required
              >
                <option value="">Select Gender</option>
                <option value="male">Male</option>
                <option value="female">Female</option>
                <option value="other">Other</option>
              </select>
            </div>
          </div>

          <div className="input-container">
            <input
              type="date"
              value={date}
              min={startDate}
              onChange={(e) => setDate(e.target.value)}
            />
          </div>

          <div className="time-slots">
            {timeSlots.length === 0 ? (
              <p
                style={{
                  textAlign: "center",
                  color: "var(--primary-color)",
                  fontWeight: "bolder",
                  marginTop: "30px",
                }}
              >
                No schedule found.
              </p>
            ) : (
              timeSlots.map((slot, index) => (
                <button
                  key={index}
                  disabled={slot.status !== "available"}
                  onClick={() => setSelectedTime(slot.time)}
                  className={`slot-btn ${
                    selectedTime === slot.time ? "selected" : ""
                  } ${slot.status !== "available" ? "disabled-slot" : ""}`}
                >
                  {slot.time}
                </button>
              ))
            )}
          </div>

          {/* {selectedConsultation === "Video" && (
            <div className="addressBook" style={{ marginTop: "20px" }}>
              <input
                type="text"
                name="street"
                placeholder="Street"
                onChange={handleAddressChange}
              />
              <input
                type="text"
                name="city"
                placeholder="City"
                onChange={handleAddressChange}
              />
              <input
                type="text"
                name="pincode"
                placeholder="Pincode"
                onChange={handleAddressChange}
              />
              <input
                type="text"
                name="district"
                placeholder="District"
                onChange={handleAddressChange}
              />
              <input
                type="text"
                name="state"
                placeholder="State"
                onChange={handleAddressChange}
              />
            </div>
          )} */}
          {selectedConsultation === "Video" && (
            <div style={{ marginTop: "20px" }}>
              <div className="addressBook">
                <div className="input-container">
                  <input
                    type="text"
                    name="street"
                    value={address.street}
                    placeholder="Street"
                    required
                    onChange={handleAddressChange}
                  />
                </div>

                <div className="input-container">
                  <input
                    type="text"
                    name="city"
                    required
                    placeholder="City"
                    value={address.city}
                    onChange={handleAddressChange}
                  />
                </div>

                <div className="input-container">
                  <input
                    type="text"
                    name="pincode"
                    required
                    placeholder="Pincode"
                    value={address.pincode}
                    onChange={handleAddressChange}
                  />
                </div>

                <div className="input-container">
                  <input
                    type="text"
                    name="district"
                    required
                    placeholder="District"
                    value={address.district}
                    onChange={handleAddressChange}
                  />
                </div>

                <div className="input-container">
                  <input
                    type="text"
                    name="state"
                    required
                    value={address.state}
                    placeholder="State"
                    onChange={handleAddressChange}
                  />
                </div>
              </div>
            </div>
          )}
          <p
            style={{
              textAlign: "center",
              margin: "10px 0px",
              fontWeight: "600",
              fontSize: "20px",
              color: "var(--primary-color",
            }}
          >
            A consultation fee of ₹{consultationAmount} will be charged.
          </p>

          <div
            className="form-container01-2"
            style={{ width: "100%", justifyContent: "space-between" }}
          >
            <button
              className="book-button01"
              style={{
                width: isMobile ? "100%" : "43%",
                borderRadius: "20px",
                fontSize: "18px",
                fontWeight: "600",
                padding: "12px",
              }}
              onClick={handleSubmit}
            >
              Book Appointment
            </button>
            <p className="contact01">( OR )</p>
            <div
              style={{
                width: isMobile ? "80%" : "43%",
                display: "flex",
                columnGap: "20px",
                alignItems: "center",
              }}
            >
              <div
                style={{
                  border: "2px solid var(--primary-color)",
                  padding: "4px 20px",
                  borderRadius: "15px",
                }}
              >
                <PiPhoneCallFill size={35} color="var(--primary-color)" />
              </div>
              <p className="phone01">+91 9129371733</p>
            </div>
          </div>
        </div>
      </div>

      {!isMobile && (
        <div className="book-container-2">
          <img src={ap1} alt="Appointment" />
        </div>
      )}

      <div className="close-icon" onClick={handleAppointment}>
        <IoMdCloseCircleOutline size={50} />
      </div>
    </div>
  );
};

export default BookAppointment;
